import { APPID, GET_USER_INSPIRATIONS, GET_USER_INSPIRATIONS_AI } from '../constants/ApiEndpoints'

export const getPrerenderedInspirations = async () => {
  const result = await fetch(GET_USER_INSPIRATIONS, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Parse-Application-Id': APPID
    },
    body: JSON.stringify({
      types: ['design', 'contest', 'pgc', 'vlog', 'blog', 'influencerPgc', 'influencerBlog', 'influencerVlog', 'blog', 'vlog'],
      isAITagged: true,
      kinds: ['featured']
    })
  })

  if (!result.ok) {
    throw new Error('Data fetching failed')
  }

  return await result.json()
}

export const getPrerenderedExploreInspirations = async (sortBy = 'numLikes', limit = 60, page = 0, following) => {
  const requestedLimit = Number.isFinite(limit) && limit > 0 ? Math.floor(limit) : 0
  const pageIndex = Number.isFinite(page) && page >= 0 ? Math.floor(page) : 0

  if (requestedLimit === 0) {
    return { result: { userInspirations: [], currentUserlikes: [], pageLimit: 0, numBlocked: 0 } }
  }

  let accumulatedInspirations = []
  const accumulatedLikes = new Set()
  let skip = pageIndex * requestedLimit
  let remaining = requestedLimit
  let lastResponse = null
  let safetyCounter = 0

  while (remaining > 0) {
    const pageLimit = Math.min(remaining, requestedLimit)

    const body = {
      isAITagged: true,
      pageLimit,
      skip
    }

    if (following) {
      body.followingIds = following
    }

    if (sortBy) {
      body.sort = sortBy
    }

    const response = await fetch(GET_USER_INSPIRATIONS_AI, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Parse-Application-Id': 3
      },
      body: JSON.stringify(body)
    })

    if (!response.ok) {
      throw new Error('Explore data fetching failed')
    }

    const data = await response.json()
    lastResponse = lastResponse || data

    const fetchedInspirations = data?.result?.userInspirations ?? []
    const fetchedLikes = data?.result?.currentUserlikes ?? []

    accumulatedInspirations = accumulatedInspirations.concat(fetchedInspirations)
    fetchedLikes.forEach(like => accumulatedLikes.add(like))

    remaining = requestedLimit - accumulatedInspirations.length
    skip += fetchedInspirations.length

    // Stop when API returns fewer items than requested or to avoid infinite loops.
    if (++safetyCounter > 10) {
      break
    }
  }

  if (!lastResponse) {
    // Should not happen, but keep the return shape consistent.
    return {
      result: {
        userInspirations: [],
        currentUserlikes: [],
        pageLimit: requestedLimit,
        numBlocked: 0
      }
    }
  }

  const mergedResult = {
    ...lastResponse.result,
    userInspirations: accumulatedInspirations.slice(0, requestedLimit),
    currentUserlikes: Array.from(accumulatedLikes),
    pageLimit: requestedLimit
  }

  return {
    ...lastResponse,
    result: mergedResult
  }
}
